<p-toast></p-toast>
<div class="w-full p-4">
    <h2 class="text-xl font-semibold text-center mt-4 mb-8">{{ this.translateServ.dictionary['STEP_BASIC_TITLE'] }}</h2>
    <div [ngClass]="isFastMode ? 'flex justify-center w-full' : 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 w-full justify-center'">
        <!-- Group 1: Business Identity -->
        <div class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
            <!-- Business ID -->
            <div class="field w-full">
                <label for="businessId" class="font-semibold mb-2">{{ translateServ.dictionary['BUSINESS_ID'] }} <span
                        class="text-red-500">*</span></label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-hashtag"></i>
                    <input pInputText id="businessId" [ngModel]="businessNumber" (ngModelChange)="onBusinessNumberChange($event)" type="text" maxlength="50"
                        placeholder="{{ translateServ.dictionary['BUSINESS_ID_PLACEHOLDER'] }}"
                        class="w-full text-center" [ngClass]="{'p-invalid': formErrors['businessId']}"
                        [disabled]="formDisabled" />
                </span>
                <small *ngIf="formErrors['businessId']" class="p-error">{{ formErrors['businessId'] }}</small>
            </div>
            <!-- Business Name -->
            <div class="field w-full">
                <label for="businessName" class="font-semibold mb-2">{{ translateServ.dictionary['BUSINESS_NAME'] }}
                    <span class="text-red-500">*</span></label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-building"></i>
                    <input pInputText id="businessName" [ngModel]="businessName" (ngModelChange)="onBusinessNameChange($event)" type="text" maxlength="100"
                        placeholder="{{ translateServ.dictionary['BUSINESS_NAME_PLACEHOLDER'] }}"
                        class="w-full text-center" [ngClass]="{'p-invalid': formErrors['businessName']}"
                        [disabled]="formDisabled" />
                </span>
                <small *ngIf="formErrors['businessName']" class="p-error">{{ formErrors['businessName'] }}</small>
            </div>
            <!-- Business Type -->
            <div class="field w-full">
                <label for="businessType" class="font-semibold mb-2">{{ translateServ.dictionary['BUSINESS_TYPE'] }}
                    <span class="text-red-500">*</span></label>
                <p-autoComplete id="businessType" [ngModel]="businessType" (ngModelChange)="onBusinessTypeChange($event)" [suggestions]="filteredBusinessTypes"
                    (completeMethod)="filterBusinessTypes($event)" [forceSelection]="true" [dropdown]="true"
                    [minLength]="1" placeholder="{{ translateServ.dictionary['BUSINESS_TYPE_PLACEHOLDER'] }}"
                    class="w-full max-w-xs mx-auto text-center" [ngClass]="{'p-invalid': formErrors['businessType']}"
                    field="label" [disabled]="formDisabled"></p-autoComplete>
                <small *ngIf="formErrors['businessType']" class="p-error">{{ formErrors['businessType'] }}</small>
            </div>
            <!-- Entity Type -->
            <div class="field w-full">
                <label for="entityType" class="font-semibold mb-2">
                    {{ translateServ.dictionary['ENTITY_TYPE'] }} <span class="text-red-500">*</span>
                </label>

                <p-autoComplete id="entityType"
                    [(ngModel)]="entityType"
                    [suggestions]="filteredEntityTypes"
                    (completeMethod)="filterEntityTypes($event)"
                    (onSelect)="onEntityTypeChange($event)"
                    [forceSelection]="true"
                    [dropdown]="true"
                    [minLength]="1"
                    [field]="'label'"
                    [optionValue]="'value'"
                    placeholder="{{ translateServ.dictionary['ENTITY_TYPE_PLACEHOLDER'] }}"
                    class="w-full max-w-xs mx-auto text-center"
                    [ngClass]="{'p-invalid': formErrors['entityType']}"
                    [disabled]="isFastMode || formDisabled">
                    <ng-template let-type pTemplate="item">
                        {{ type.label }}
                    </ng-template>
                </p-autoComplete>

                <small *ngIf="formErrors['entityType']" class="p-error">{{ formErrors['entityType'] }}</small>
            </div>
            <!-- Expense Code (only for Customer) -->
            <div class="field w-full" *ngIf="isEntityTypeCustomer()">
                <label for="expenseCode" class="font-semibold mb-2">{{ translateServ.dictionary['INPUT_VAT'] }} <span class="text-red-500">*</span></label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-money-bill"></i>
                    <input pInputText id="expenseCode" [(ngModel)]="expenseCode" type="text" maxlength="50"
                        placeholder="{{ translateServ.dictionary['INPUT_VAT_PH'] || 'Enter expense code' }}"
                        class="w-full text-center" [ngClass]="{'p-invalid': formErrors['expenseCode']}" [disabled]="formDisabled" />
                </span>
                <small *ngIf="formErrors['expenseCode']" class="p-error">{{ formErrors['expenseCode'] }}</small>
            </div>
            <!-- Withholding Tax Code + Account (only for Customer) -->
            <div class="field w-full" *ngIf="isEntityTypeCustomer()">
                <label class="font-semibold mb-2">{{ translateServ.dictionary['MAINT_CS_TIT_WH_TAX']}}</label>
                <div class="flex flex-row gap-4 justify-center w-full">
                    <span class="p-input-icon-left w-full max-w-xs mx-auto">
                        <i class="pi pi-file"></i>
                        <input pInputText id="withholdingTaxCode" [(ngModel)]="withholdingTaxCode" type="text" maxlength="50"
                            placeholder="{{ translateServ.dictionary['WITHHOLDING_TAX_PLACEHOLDER'] || 'Enter withholding tax code' }}"
                            class="w-full text-center" [disabled]="formDisabled" />
                    </span>
                    <span class="p-input-icon-left w-full max-w-xs mx-auto">
                        <i class="pi pi-id-card"></i>
                        <input pInputText id="withholdingAccount" [(ngModel)]="withholdingAccount" type="text" maxlength="50"
                            placeholder="{{ translateServ.dictionary['WITHHOLDING_ACCOUNT_PLACEHOLDER'] || 'Enter withholding account' }}"
                            class="w-full text-center" [disabled]="formDisabled" />
                    </span>
                </div>
                <div class="flex gap-4 justify-center mt-2">
                    <small *ngIf="formErrors['withholdingTaxCode']" class="p-error">{{ formErrors['withholdingTaxCode'] }}</small>
                    <small *ngIf="formErrors['withholdingAccount']" class="p-error">{{ formErrors['withholdingAccount'] }}</small>
                </div>
            </div>
            <!-- Union Business ID -->
            <div class="field w-full">
                <label for="unionBusinessId" class="font-semibold mb-2">{{ translateServ.dictionary['UNION_BUSINESS_ID']
                    }}</label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-hashtag"></i>
                    <input pInputText id="unionBusinessId" [(ngModel)]="unionBusinessId" type="text" maxlength="50"
                        placeholder="{{ translateServ.dictionary['UNION_BUSINESS_ID_PLACEHOLDER'] }}"
                        class="w-full text-center" [disabled]="formDisabled" />
                </span>
            </div>
            <!-- Date Established -->
            <div class="field w-full">
                <label for="establishedDate" class="font-semibold mb-2">{{ translateServ.dictionary['ESTABLISHED_DATE']
                    }}</label>
                <p-datepicker id="establishedDate" [(ngModel)]="establishedDate" dateFormat="dd/mm/yy" [showIcon]="true"
                    [showButtonBar]="true" class="w-full max-w-xs mx-auto text-center"
                    (onSelect)="onCalendarSelect($event)" (onClick)="onCalendarClick($event)"
                    [disabled]="formDisabled"></p-datepicker>
            </div>
        </div>
        <!-- Group 2: Contact & Owner -->
        <div *ngIf="!isFastMode" class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
            <!-- Contact Name -->
            <div class="field w-full">
                <label for="contactName" class="font-semibold mb-2">{{ translateServ.dictionary['CONTACT_NAME']
                    }}</label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-user"></i>
                    <input pInputText id="contactName" [(ngModel)]="contactName" type="text" maxlength="50"
                        placeholder="{{ translateServ.dictionary['CONTACT_NAME_PLACEHOLDER'] }}"
                        class="w-full text-center" pattern="^[^\d]*$" [disabled]="formDisabled" />
                </span>
            </div>
            <!-- Contact Title -->
            <div class="field w-full">
                <label for="contactTitle" class="font-semibold mb-2">{{ translateServ.dictionary['CONTACT_TITLE']
                    }}</label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-id-card"></i>
                    <input pInputText id="contactTitle" [(ngModel)]="contactTitle" type="text" maxlength="50"
                        placeholder="{{ translateServ.dictionary['CONTACT_TITLE_PLACEHOLDER'] }}"
                        class="w-full text-center" pattern="^[^\d]*$" [disabled]="formDisabled" />
                </span>
            </div>
            <!-- Owner First Name -->
            <div class="field w-full">
                <label for="ownerFirstName" class="font-semibold mb-2">{{ translateServ.dictionary['OWNER_FIRST_NAME']
                    }}</label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-user"></i>
                    <input pInputText id="ownerFirstName" [(ngModel)]="ownerFirstName" type="text" maxlength="50"
                        placeholder="{{ translateServ.dictionary['OWNER_FIRST_NAME_PLACEHOLDER'] }}"
                        class="w-full text-center" pattern="^[^\d]*$" [disabled]="formDisabled" />
                </span>
            </div>
            <!-- Owner Last Name -->
            <div class="field w-full">
                <label for="ownerLastName" class="font-semibold mb-2">{{ translateServ.dictionary['OWNER_LAST_NAME']
                    }}</label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-user"></i>
                    <input pInputText id="ownerLastName" [(ngModel)]="ownerLastName" type="text" maxlength="50"
                        placeholder="{{ translateServ.dictionary['OWNER_LAST_NAME_PLACEHOLDER'] }}"
                        class="w-full text-center" pattern="^[^\d]*$" [disabled]="formDisabled" />
                </span>
            </div>
        </div>
        <!-- Group 3: Details & Status -->
        <div *ngIf="!isFastMode" class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
            <!-- Note -->
            <div class="field w-full">
                <label for="note" class="font-semibold mb-2 block text-center">{{ translateServ.dictionary['NOTE']
                    }}</label>
                <textarea pInputText id="note" [(ngModel)]="note" maxlength="250" rows="2"
                    placeholder="{{ translateServ.dictionary['NOTE_PLACEHOLDER'] }}"
                    class="w-full max-w-xs mx-auto text-center" [disabled]="formDisabled"></textarea>
                <small class="text-gray-400">{{ note.length || 0 }}/250</small>
            </div>
            <!-- Description -->
            <div class="field w-full">
                <label for="description" class="font-semibold mb-2 block text-center">{{
                    translateServ.dictionary['DESCRIPTION'] }}</label>
                <textarea pInputText id="description" [(ngModel)]="description" maxlength="250" rows="2"
                    placeholder="{{ translateServ.dictionary['DESCRIPTION_PLACEHOLDER'] }}"
                    class="w-full max-w-xs mx-auto text-center" [disabled]="formDisabled"></textarea>
                <small class="text-gray-400">{{ description.length || 0 }}/250</small>
            </div>
            <!-- Small Expense Value -->
            <div class="field w-full">
                <label for="smallExpenseValue" class="font-semibold mb-2">{{
                    translateServ.dictionary['SMALL_EXPENSE_VALUE'] }} ₪</label>
                <span class="p-input-icon-left w-full max-w-xs mx-auto">
                    <i class="pi pi-money-bill"></i>
                    <input pInputText id="smallExpenseValue" [(ngModel)]="smallExpenseValue" type="number" min="0"
                        step="0.01" placeholder="{{ translateServ.dictionary['SMALL_EXPENSE_VALUE_PLACEHOLDER'] }}"
                        class="w-full text-center" [disabled]="formDisabled" />
                </span>
            </div>
            <!-- Is Company Active in Real Life (AutoComplete) -->
            <div class="field w-full">
                <label for="isCompanyActive" class="font-semibold mb-2">{{
                    translateServ.dictionary['IS_COMPANY_ACTIVE_REAL'] || 'Company Operational Status' }} <span
                        class="text-red-500">*</span></label>
                <p-autoComplete id="isCompanyActive" [(ngModel)]="isCompanyActive" [suggestions]="filteredActivityTypes"
                    (completeMethod)="filterActivityTypes($event)" [forceSelection]="true" [dropdown]="true"
                    [minLength]="1"
                    placeholder="{{ translateServ.dictionary['IS_COMPANY_ACTIVE_REAL_PH'] || 'Select operational status' }}"
                    class="w-full max-w-xs mx-auto text-center" [ngClass]="{'p-invalid': formErrors['isCompanyActive']}"
                    field="label" [disabled]="formDisabled"></p-autoComplete>
                <small *ngIf="formErrors['isCompanyActive']" class="p-error">{{ formErrors['isCompanyActive'] }}</small>
                <!-- Grouped Checkboxes -->
                <div class="flex flex-row justify-center items-center gap-6 mt-4">
                    <div class="flex items-center gap-2">
                        <p-checkbox inputId="isActive" [ngModel]="isActive" (ngModelChange)="onIsActiveChange($event)" binary="true"
                            [disabled]="formDisabled"></p-checkbox>
                        <label for="isActive" class="font-semibold">{{ translateServ.dictionary['IS_ACTIVE'] }}</label>
                    </div>
                    <div class="flex items-center gap-2">
                        <p-checkbox inputId="isApproved" [(ngModel)]="isApproved" binary="true"
                            [disabled]="formDisabled"></p-checkbox>
                        <label for="isApproved" class="font-semibold">{{ translateServ.dictionary['IS_APPROVED']
                            }}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="flex pt-6 justify-end w-full gap-4">
        <p-button (onClick)="createAccount()" label="{{ translateServ.dictionary['CREATE_NEW']}}"
            [disabled]="creationSuccess" icon="pi pi-check" class="mx-auto"></p-button>
        <p-button (onClick)="isFastMode ? completeProcess() : nextStepHandler()"
            [label]="isFastMode ? (translateServ.dictionary['PREV_BTN_SAVE']) : (translateServ.dictionary['NEXT'])"
            [icon]="dirServ.isRtl() ? 'pi pi-arrow-left' : 'pi pi-arrow-right'"
            [iconPos]="dirServ.isRtl() ? 'left' : 'right'" [disabled]="!creationSuccess" class="mx-auto"></p-button>
    </div>
</div>